<div class="table-responsive">
  <table class="table table-striped table-hover">
    <thead class="table-light">
    <tr>
      <th>{{ isDaily() ? 'Date' : 'Label' }}</th>
      <th>Clicks</th>
      <th>Uniques</th>
      <th>Conversions</th>
      <th>Conversion Rate (%)</th>
      <th>Revenue</th>
      <th>EPC</th>
    </tr>
    </thead>
    <tbody>
    <ng-container *ngIf="!loader.isLoading()">
      <tr *ngFor="let statistic of statistics; let last = last" [class.table-light]="last" [class.border-2]="last">
        <td>
          <ng-container *ngIf="last">Totals</ng-container>
          <ng-container *ngIf="!last">
            <ng-container *ngIf="isDaily()">{{ statistic.getDate() | date: 'dd/MM/yyyy' }}</ng-container>
            <ng-container *ngIf="!isDaily()">{{ statistic }}</ng-container>
          </ng-container>
        </td>
        <td>{{ statistic.clicks }}</td>
        <td>{{ statistic.uniqueClicks ?? 0 }}</td>
        <td>{{ statistic.conversions ?? 0 }}</td>
        <td>{{ (statistic.conversionRate ?? 0) | percent }}</td>
        <td>{{ (statistic.revenue ?? 0) | money }}</td>
        <td>{{ (statistic.epc ?? 0) | money }}</td>
      </tr>
    </ng-container>
    </tbody>
  </table>
</div>
